import { getLanguage } from '@/utils/locale';
import { onBeforeMount, ref } from 'vue';

/**
 * RTL 语言列表
 * ar: 阿拉伯语
 * iw/he: 希伯来语
 * ur: 乌尔都语
 * ug: 维吾尔语
 * fa: 波斯语
 */
const RTL_LANGUAGES = ['ar', 'iw', 'he', 'ur', 'ug', 'fa'];

const dir = ref<'ltr' | 'rtl'>('ltr');
let hasInitialized = false;

/**
 * 配置文档的语言和方向的 Hook
 */
function useDocumentLang() {
    // 判断是否为 RTL 语言 (提取语言主码后精确匹配, 兼容 ar / ar_SA / ar-SA 等格式)
    const isRTL = (lang: string) => {
        const primaryLang = lang.split(/[_-]/)[0];
        return RTL_LANGUAGES.includes(primaryLang);
    };

    // 设置文档语言和方向
    const setupDocument = () => {
        if (hasInitialized) {
            return;
        }

        // 获取语言, 默认英语
        const lang = getLanguage();
        // 设置语言
        document.documentElement.setAttribute('lang', lang);

        // 确定文档方向, 更新模块级 dir ref
        dir.value = isRTL(lang) ? 'rtl' : 'ltr';
        // 设置方向
        document.documentElement.setAttribute('dir', dir.value);

        hasInitialized = true;
    };

    // 组件挂载前执行配置
    onBeforeMount(() => {
        setupDocument();
    });

    return { dir };
}

export default useDocumentLang;
